import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {Usuario} from '../model/usuario';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const sessionStr = localStorage.getItem(ParametrosConst.USUARIO_LOGIN);
    const menuStr = localStorage.getItem(ParametrosConst.USUARIO_MENU);
    const menu = (menuStr) ? JSON.parse(localStorage.getItem(ParametrosConst.USUARIO_MENU)) : null;
    const usuario: Usuario = (sessionStr) ? JSON.parse(sessionStr) as Usuario : null;

    if (
      menu !== null &&
      usuario !== null &&
      usuario.sesion === '0' &&
      state.url.indexOf(ParametrosConst.URL_ROUTER_CAMBIO_CONTRASENIA.replace('/', '')) > 0
    ) {
      // si esta llendo a cambiar contrasaeña
      return true;
    } else if (
      menu !== null &&
      localStorage.getItem(ParametrosConst.TOKEN) !== null &&
      usuario.sesion === '1'
    ) {
      // logged in so return true
      // SETE TOKEN
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/ingreso'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}
